import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import {UserProvider} from "../../providers/user";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Validator} from "../../validator";
import {TeamappProvider} from "../../providers/teamapp";
import {ImageProvider} from "../../providers/image";
import {Camera} from "@ionic-native/camera";

/**
 * Generated class for the ChatGroupAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-chat-group-add',
  templateUrl: 'chat-group-add.html',
})
export class ChatGroupAddPage {
  private group: any = {
    image: '',
    title: '',
    description: ''
  };

  private groupForm: FormGroup;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public userProvider: UserProvider,
      public formBuilder: FormBuilder,
      public teamappProvider: TeamappProvider,
      public imageProvider: ImageProvider,
      public camera: Camera,
      public alertCtrl: AlertController
  ) {

    this.groupForm = formBuilder.group({
      name: Validator.groupNameValidator,
      description: Validator.groupDescriptionValidator
    });
  }

  setGroupPhoto() {
    this.imageProvider.uploadPhotoToChatServer(this.camera.PictureSourceType.CAMERA).then((url) => {
        this.group.image = url;
    });
  }

  done() {
    this.group.name = this.group.name.replace('?', '%3F');
    this.group.name = this.group.name.replace('&', '%26');

    this.group.description = this.group.description.replace('?', '%3F');
    this.group.description = this.group.description.replace('&', '%26');

    this.teamappProvider.http_request('action=add_new_group&target='+this.group.name+'&content='+this.group.description+'&image_source='+this.group.image, 'chat', false, true).then(data => {

      this.alertCtrl.create({
        title: 'Gruppe',
        message: "Die Gruppe <b>"+this.group.name+"</b> wurde erfolgreich erstellt",
        buttons: [
          {
            text: 'Ok',
            handler: data => {
              this.navCtrl.pop();
            }
          }
        ]
      }).present();

    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/chat-group-add/chat-group-add.ts